import React from "react";

const OPTIONAL_SECTIONS = [
  {
    key: "platformPerformance",
    label: "Platform Performance",
    description: "Show your follower counts, views, and engagement by platform.",
  },
  {
    key: "audience",
    label: "Audience & Demographics",
    description: "Show who your audience is and where they're located.",
  },
  {
    key: "brandPartners",
    label: "Brand Partners",
    description: "Display logos of the brands you've worked with.",
  },
  {
    key: "collaborations",
    label: "Collaboration Highlights",
    description: "Show case studies of past campaigns.",
  },
  {
    key: "featuredPosts",
    label: "Featured Posts",
    description: "Highlight your best TikToks, Reels, or Shorts.",
  },
];

function SectionsModal({ isOpen, onClose, sectionsEnabled, hasData, onUpdateSectionsEnabled }) {
  if (!isOpen) return null;

  const current = sectionsEnabled || {};
  const data = hasData || {};

  const handleToggle = (key) => {
    // Platform Performance is default-on: effective state is (current[key] !== false)
    const effectiveEnabled = key === "platformPerformance" ? (current[key] !== false) : !!current[key];
    const next = { ...current, [key]: !effectiveEnabled };
    onUpdateSectionsEnabled(next);
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-slate-900/40"
        onClick={onClose}
      />

      {/* Panel */}
      <div className="relative z-50 w-full max-w-lg rounded-xl bg-white shadow-xl border border-slate-200 mx-4 max-h-[90vh] flex flex-col">
        {/* Header */}
        <div className="px-5 pt-4 pb-3 border-b border-slate-200 flex-shrink-0">
          <h2 className="text-base md:text-lg font-semibold text-slate-900">
            Customize your InfluenceHub
          </h2>
          <p className="mt-1 text-xs sm:text-sm text-slate-500">
            Start with your identity and About Me. Turn on additional sections when you&apos;re ready.
          </p>
        </div>

        {/* Content - Scrollable */}
        <div className="px-5 py-4 space-y-3 overflow-y-auto flex-1">
          {OPTIONAL_SECTIONS.map((section) => {
            const key = section.key;
            // Platform Performance is default-on: treat undefined as shown
            const enabled = key === "platformPerformance" ? (current[key] !== false) : !!current[key];
            const hasSectionData = !!data[key];

            return (
              <div
                key={key}
                className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-3 border border-slate-200 rounded-md px-3 py-2"
              >
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="text-sm font-medium text-slate-900">
                      {section.label}
                    </span>
                    {hasSectionData && (
                      <span className="inline-flex items-center rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-medium text-emerald-700">
                        Has data
                      </span>
                    )}
                  </div>
                  <p className="text-xs text-slate-500 mt-0.5">
                    {section.description}
                  </p>
                </div>
                <div className="flex items-center justify-end">
                  <button
                    type="button"
                    onClick={() => handleToggle(key)}
                    className={
                      enabled
                        ? "inline-flex items-center rounded-full bg-slate-900 px-3 py-1.5 text-xs font-semibold text-white hover:bg-slate-800 transition-colors"
                        : "inline-flex items-center rounded-full bg-white px-3 py-1.5 text-xs font-semibold text-slate-700 border border-slate-300 hover:bg-slate-50 transition-colors"
                    }
                  >
                    {enabled ? "Shown on profile" : "Show on profile"}
                  </button>
                </div>
              </div>
            );
          })}
        </div>

        {/* Footer */}
        <div className="px-5 py-3 border-t border-slate-200 flex justify-end flex-shrink-0">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex items-center rounded-md border border-slate-300 bg-white px-4 py-2 text-xs sm:text-sm font-semibold text-slate-700 hover:bg-slate-50 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default SectionsModal;



